import { css, cx, mediaQueries } from '@eti/styles';
import { jsx as _jsx } from "react/jsx-runtime";
const contentWrapperStyles = css`
  margin: 0 auto;
  padding: 0 10px;
  width: 100%;

  @media ${mediaQueries.medium.up} {
    max-width: 750px;
    padding: 0 15px;
  }

  @media ${mediaQueries.large.up} {
    max-width: 970px;
  }

  @media ${mediaQueries.xlarge.up} {
    max-width: 1170px;
  }
`;
const ContentWrapper = _ref => {
  let {
    children,
    className,
    dataTestId,
    customRef
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: cx('etiContentWrapper', contentWrapperStyles, className),
    "data-testid": dataTestId,
    ref: customRef,
    children: children
  });
};
export default ContentWrapper;